import React from 'react';
import Select from "react-select";
import {Glob as G} from "../../libs/Glob.mjs";
import adminLib from "../../libs/adminLib.mjs";

const AddFieldBar = class extends React.Component {
	constructor(props) {
		super(props);
		this.state = {};
		this.state.options = props.fieldTypes
			.filter(x => !x.unique || ! props.fields.find( f => f.type === x.type))
			.sort( (a, b) => a.name.localeCompare(b.name))
			.map(f => ({label: f.name, value: f.type} ) );
	}
	render() {
		return(
			<div className={"field"}>
				<div className={"AddFieldBar"}>
					{ this.props.label ? (
						<span>
							{ this.props.label }:
						</span>
					) : ''}
					<div>
						<Select
							placeholder={G.label('Select') }
							options={ this.state.options }
							onChange={(x) => {
								const id = G.generateUid('field');
								if (x?.value) this.props.commit({type: x.value, uuid: id});
								setTimeout( ()=>{
									adminLib.editorScrollToFieldID(id);
								}, 500);
							}}
						/>
					</div>
				</div>
			</div>
		)
	}
}

export default AddFieldBar;